"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_view_document_instance_controller_1 = __importDefault(require("./view/admin-view-document-instance.controller"));
var admin_view_document_instance_html_1 = __importDefault(require("./view/admin-view-document-instance.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.documentinstance", {
        url: "/documents/instances/:id",
        template: admin_view_document_instance_html_1.default,
        controller: "AdminViewDocumentInstanceController",
        controllerAs: "vm",
        data: {
            pageTitle: "View Document",
            breadcrumb: "View Document",
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.document-instances", [])
    .controller("AdminViewDocumentInstanceController", admin_view_document_instance_controller_1.default)
    .config(config);
